<template>
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
  >
    <path d="M7.74664 6C7.74664 5.17157 7.07507 4.5 6.24664 4.5C5.41822 4.5 4.74664 5.17157 4.74664 6C4.74664 6.82843 5.41822 7.5 6.24664 7.5C7.07507 7.5 7.74664 6.82843 7.74664 6ZM12.2466 6C12.2466 8.8739 9.1494 12.0162 7.4055 13.5577C6.73714 14.1485 5.75615 14.1485 5.08778 13.5577C3.34388 12.0162 0.246643 8.8739 0.246643 6C0.246643 2.68629 2.93293 0 6.24664 0C9.56035 0 12.2466 2.68629 12.2466 6ZM11.2466 6C11.2466 3.23858 9.00807 1 6.24664 1C3.48522 1 1.24664 3.23858 1.24664 6C1.24664 7.10846 1.86129 8.39535 2.81636 9.68269C3.7503 10.9415 4.90358 12.0602 5.75008 12.8085C6.0402 13.065 6.45308 13.065 6.74321 12.8085C7.5897 12.0602 8.74298 10.9415 9.67692 9.68269C10.632 8.39535 11.2466 7.10846 11.2466 6Z" />
  </svg>
</template>
